import { useMemo } from "react";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";

const useIsActive = () => {
  const { activeContentKey } = useMemberToobarContext();

  const isActive = useMemo(() => {
    return activeContentKey === contentKeys.login;
  }, [activeContentKey]);

  return isActive;
};

export { useIsActive };
